module.exports = __webpack_public_path__ + "media/images/meta/pakalpojumu_sniedzeji-f4bfee46cc615ebafe3f6fa4624d0873.jpg";